<template>
  <div class="table-header__paginator">
    <span>стр.</span>
    <span class="left-arrow" :class="{ disabled: currentPage === 1 }" @click="onPageBack" />
    <input
      ref="currentPage"
      :value="currentPage"
      type="text"
      @keyup="onKeyUpPage($event)"
      @keyup.enter="savePageNumber"
      @blur="savePageNumber"
    />
    <span class="right-arrow" :class="{ disabled: currentPage === Math.ceil(maxCount / pageSize) }" @click="onPageForth" />
    <span>из {{ Math.ceil(maxCount / pageSize) }}</span>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "TablePaginator",
  props: {
    maxCount: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: parseInt(process.env.VUE_APP_PAGE_SIZE, 10) || 15
    }
  },
  data() {
    return {
      enteredValue: null,
      previousCorrectPage: null
    };
  },
  computed: {
    currentPage: {
      get: function() {
        return this.$store.getters["hashManager/getRouteOption"]({ route: this.$route, option: "page" }) || 1;
      },
      set: function(newValue) {
        this.addRouteOptions({
          path: this.$route.path,
          options: {
            page: newValue
          },
          route: this.$route
        });
      }
    }
  },
  // watch: {
  //   "$props.maxCount"() {
  //     this.currentPage = 1;
  //   }
  // },
  mounted() {
    this.previousCorrectPage = this.currentPage;
    this.enteredValue = this.currentPage;
  },
  methods: {
    ...mapActions("hashManager", ["addRouteOptions"]),
    onKeyUpPage(e) {
      const value = e.target.value;
      const match = value.match(/\d+/g);
      let newValue = "";
      const maxPage = Math.ceil(this.maxCount / this.pageSize);

      if (match && match[0]) {
        newValue = match[0][0] === "0" ? match[0].slice(-(match[0].length - 1)) : match[0];
      } else {
        this.enteredValue = this.previousCorrectPage;
        // this.$emit("change-page", this.currentPage);
        return;
      }

      newValue = parseInt(newValue, 10);
      if (newValue > maxPage) {
        newValue = maxPage;
      }

      if (newValue === 0) {
        newValue = 1;
      }
      this.enteredValue = newValue;
      // this.$emit("change-page", this.tablePage);
    },
    async savePageNumber() {
      this.currentPage = this.enteredValue;
      await this.$nextTick();
      this.$refs.currentPage.value = this.currentPage;
      this.previousCorrectPage = this.enteredValue;
    },
    onPageBack() {
      const page = parseInt(this.currentPage, 10);

      if (page !== 1) {
        this.currentPage = page - 1;
        // this.$emit("change-page", this.tablePage);
      }
    },
    onPageForth() {
      const page = Number(this.currentPage);

      if (page === 1 && this.maxCount === 0) {
        return;
      }

      if (page !== Math.ceil(this.maxCount / this.pageSize)) {
        this.currentPage = page + 1;
        // this.$emit("change-page", this.tablePage);
      }
    }
  }
};
</script>
